import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

export const config = {
    id: ActionType.IMPORT_ONLINE_SLIDE,
    /* eslint-disable */ // 租户文案动态注入
    title: TENANT_CONFIG.TENANT_DOC_NAME ? `从${TENANT_CONFIG.TENANT_DOC_NAME}` : i18n.t('从腾讯文档'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.title,
    },
];
